/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetAllServiceProviders200ResponseServiceProvidersInnerClientsAuditInner } from './GetAllServiceProviders200ResponseServiceProvidersInnerClientsAuditInner';
import {
    GetAllServiceProviders200ResponseServiceProvidersInnerClientsAuditInnerFromJSON,
    GetAllServiceProviders200ResponseServiceProvidersInnerClientsAuditInnerFromJSONTyped,
    GetAllServiceProviders200ResponseServiceProvidersInnerClientsAuditInnerToJSON,
    GetAllServiceProviders200ResponseServiceProvidersInnerClientsAuditInnerToJSONTyped,
} from './GetAllServiceProviders200ResponseServiceProvidersInnerClientsAuditInner';
import type { GetAllServiceProviders200ResponseServiceProvidersInnerClientsMonitoringInner } from './GetAllServiceProviders200ResponseServiceProvidersInnerClientsMonitoringInner';
import {
    GetAllServiceProviders200ResponseServiceProvidersInnerClientsMonitoringInnerFromJSON,
    GetAllServiceProviders200ResponseServiceProvidersInnerClientsMonitoringInnerFromJSONTyped,
    GetAllServiceProviders200ResponseServiceProvidersInnerClientsMonitoringInnerToJSON,
    GetAllServiceProviders200ResponseServiceProvidersInnerClientsMonitoringInnerToJSONTyped,
} from './GetAllServiceProviders200ResponseServiceProvidersInnerClientsMonitoringInner';

/**
 * 
 * @export
 * @interface GetAllServiceProviders200ResponseServiceProvidersInnerClients
 */
export interface GetAllServiceProviders200ResponseServiceProvidersInnerClients {
    /**
     * 
     */
    monitoring?: Array<GetAllServiceProviders200ResponseServiceProvidersInnerClientsMonitoringInner>;
    /**
     * 
     */
    audit?: Array<GetAllServiceProviders200ResponseServiceProvidersInnerClientsAuditInner>;
    /**
     * 
     */
    quickcheck?: Array<GetAllServiceProviders200ResponseServiceProvidersInnerClientsAuditInner>;
}

/**
 * Check if a given object implements the GetAllServiceProviders200ResponseServiceProvidersInnerClients interface.
 */
export function instanceOfGetAllServiceProviders200ResponseServiceProvidersInnerClients(value: object): value is GetAllServiceProviders200ResponseServiceProvidersInnerClients {
    return true;
}

export function GetAllServiceProviders200ResponseServiceProvidersInnerClientsFromJSON(json: any): GetAllServiceProviders200ResponseServiceProvidersInnerClients {
    return GetAllServiceProviders200ResponseServiceProvidersInnerClientsFromJSONTyped(json, false);
}

export function GetAllServiceProviders200ResponseServiceProvidersInnerClientsFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAllServiceProviders200ResponseServiceProvidersInnerClients {
    if (json == null) {
        return json;
    }
    return {
        
        'monitoring': json['monitoring'] == null ? undefined : ((json['monitoring'] as Array<any>).map(GetAllServiceProviders200ResponseServiceProvidersInnerClientsMonitoringInnerFromJSON)),
        'audit': json['audit'] == null ? undefined : ((json['audit'] as Array<any>).map(GetAllServiceProviders200ResponseServiceProvidersInnerClientsAuditInnerFromJSON)),
        'quickcheck': json['quickcheck'] == null ? undefined : ((json['quickcheck'] as Array<any>).map(GetAllServiceProviders200ResponseServiceProvidersInnerClientsAuditInnerFromJSON)),
    };
}

export function GetAllServiceProviders200ResponseServiceProvidersInnerClientsToJSON(json: any): GetAllServiceProviders200ResponseServiceProvidersInnerClients {
    return GetAllServiceProviders200ResponseServiceProvidersInnerClientsToJSONTyped(json, false);
}

export function GetAllServiceProviders200ResponseServiceProvidersInnerClientsToJSONTyped(value?: GetAllServiceProviders200ResponseServiceProvidersInnerClients | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'monitoring': value['monitoring'] == null ? undefined : ((value['monitoring'] as Array<any>).map(GetAllServiceProviders200ResponseServiceProvidersInnerClientsMonitoringInnerToJSON)),
        'audit': value['audit'] == null ? undefined : ((value['audit'] as Array<any>).map(GetAllServiceProviders200ResponseServiceProvidersInnerClientsAuditInnerToJSON)),
        'quickcheck': value['quickcheck'] == null ? undefined : ((value['quickcheck'] as Array<any>).map(GetAllServiceProviders200ResponseServiceProvidersInnerClientsAuditInnerToJSON)),
    };
}

